const user = JSON.parse(localStorage.getItem("webuser"));

const initialState = user
	? {
			isLoggedIn: true,
			user,
			module: "",
			currentPageSize: 20,
			pageSizes: [5, 10, 20, 30, 50],
			loading: true,
			orders: [
				{
					label: "Asc",
					value: "asc",
				},
				{
					label: "Desc",
					value: "desc",
				},
			],
	  }
	: { isLoggedIn: false, user: null };

const commonReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case "CURRENT_USER":
			return {
				...state,
			};
		case "CURRENT_MODULE":
			return {
				...state,
				module: payload,
			};
		case "CURRENT_PAGE_SIZE":
			return {
				...state,
				currentPageSize: payload,
			};
		case "SET_LOADING":
			return {
				...state,
				loading: payload,
			};
		case "LOGOUT":
			return {
				...state,
				user: null,
			};
		default:
			return {
				...state,
			};
	}
};
export default commonReducer;
